import {DreRowEntity} from "../../../../domain/entity/dre-row.entity";

export function dreRowSort(a: DreRowEntity, b: DreRowEntity): number {
    if (a.order > b.order) return 1;
    if (a.order < b.order) return -1;
    return 0;
}